const Program = (): any => {
  let internalValue: string | undefined;

  return {
    set: (program: string): void => {
      internalValue = program;
    },
    get: (): string | undefined => {
      return internalValue;
    },
    clear: (): void => {
      internalValue = undefined;
    },
  };
};

export default Program();
